import { UpdateUserRequest, User } from "@/types";
import { apiFetch } from "../fetch";

export async function getUser(
  identifier: string,
  token?: string,
): Promise<User> {
  return apiFetch<User>(`/users/${encodeURIComponent(identifier)}`, {
    method: "GET",
    headers: {
      //TO DO: THIS SHOULD BE TEMPORARILY
      "x-saasbase-project-id": "proj_usswhqkxqa0qnajky2521dx2oem3d1uf6l",
    },
    // token,
  });
}

export async function updateUser(
  identifier: string,
  data: UpdateUserRequest,
): Promise<User> {
  return apiFetch<User>(`/users/${encodeURIComponent(identifier)}`, {
    method: "PATCH",
    body: JSON.stringify(data),
    headers: {
      //TO DO: THIS SHOULD BE TEMPORARILY
      "x-saasbase-project-id": "proj_usswhqkxqa0qnajky2521dx2oem3d1uf6l",
    },
  });
}
